import { Component, Input } from '@angular/core';
import { UrlHelper } from 'src/app/core/services/helpers/url-helper.service';

interface Contact {
  type: 'DEFAULT' | 'PARENT' | 'CHILD';
  title: string;
  phone?: string;
  image?: string;
}

@Component({
  selector: 'mapfre-phone-contact',
  templateUrl: './phone-contact.component.html',
  styleUrls: ['./phone-contact.component.scss']
})
export class PhoneContactComponent {
  @Input() contact: Contact = {} as any;

  constructor(public urlHelper: UrlHelper) {}
}
